import axios from "axios";
import React, { useEffect, useState } from "react";
import loginbg from "../Assets/Images/loginbg.jpg";

function Policy() {
  const [content, setContent] = useState("");
    const [theme, setTheme] = useState("light");
  useEffect(() => {
    axios
      .get("/office/staticpages/privacypolicy.html")
      .then((response) => setContent(response.data))
      .catch((error) => console.error("Error fetching the content:", error));
  }, []);
  useEffect(() => {
        setTheme(document.body.classList.contains('light-skin') ? "light" : "dark");
        let ele = document.getElementById("root");
        ele.classList.add("h-p100");
        return () => ele.classList.remove("h-p100");
    }, [])
  return (
    <div
      className="container"
      style={{
        background: `url(${loginbg})`,
        backgroundSize: "cover",
        width: "100%",
        maxWidth: "100%",
      }}
    >
      <div className="row h-p100" style={{ backgroundColor: "#efefef4a" }}>
        <div
          className="col-12"
          style={{ overflowY: "scroll", height: "100vh" }}
        >
          <div
            class={`${
              theme === "light" ? "bg-white" : "bg-gray-900"
            } rounded10 shadow-lg`}
            style={{padding:20,margin:20}}
          >
            <div
              class="container"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Policy;
